import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ResidentAppError } from '../../../../common/error'
import { ResidentAppErrorCode } from '../../../../common/types'
import { ContractChangesViewState } from '../types'

export const useConfirmationReturnParams = (
  setView: (view: ContractChangesViewState) => void
) => {
  const [params] = useSearchParams()

  useEffect(() => {
    // Show success view if the operation was successfully confirmed
    if (params.get('success')) {
      setView('success')
    }

    // Throw backend errors
    const error = params.get('error')

    if (error) {
      // The error is handled in the ErrorHandler component
      throw ResidentAppError.ClientError(error as ResidentAppErrorCode)
    }
  }, [params, setView])
}
